var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Card, Checkbox, Col, Row, Select, TextField } from '@folio/stripes/components';
import React from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { DataTokenType, HeaderFooterTokenType } from '../../types';
export var TOKEN_TYPES_WITH_LENGTH_CONTROL = [
    HeaderFooterTokenType.CURRENT_DATE,
    HeaderFooterTokenType.AGGREGATE_COUNT,
    HeaderFooterTokenType.AGGREGATE_TOTAL,
    DataTokenType.CURRENT_DATE,
    DataTokenType.ACCOUNT_AMOUNT,
    DataTokenType.ACCOUNT_DATE,
    DataTokenType.FEE_FINE_TYPE,
    DataTokenType.ITEM_INFO,
    DataTokenType.USER_DATA,
    DataTokenType.AGGREGATE_COUNT,
    DataTokenType.AGGREGATE_TOTAL,
];
function FakeHeader() {
    return React.createElement("div", null);
}
export default function LengthControlDrawer(_a) {
    var prefix = _a.prefix;
    var intl = useIntl();
    var isTruncateEnabled = useField("".concat(prefix, "truncate"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : false; },
    }).input.value;
    return (React.createElement(Card, { headerComponent: FakeHeader, headerStart: React.createElement("div", null) },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6, md: 3 },
                React.createElement(Field, { name: "".concat(prefix, "length") }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, type: "number", min: 1, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.lengthControl.length" }) }))); })),
            React.createElement(Col, { xs: 6, md: 3 },
                React.createElement(Field, { name: "".concat(prefix, "character") }, function (fieldProps) { return (React.createElement(TextField, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, maxLength: 1, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.lengthControl.filler" }) }))); })),
            React.createElement(Col, { xs: 6, md: 3 },
                React.createElement(Field, { name: "".concat(prefix, "direction"), defaultValue: "FRONT" }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { marginBottom0: true, label: isTruncateEnabled
                        ? React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.lengthControl.direction.addOrTruncate" })
                        : React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.lengthControl.direction.addOnly" }), dataOptions: [
                        { label: intl.formatMessage({ id: 'ui-plugin-bursar-export.bursarExports.lengthControl.direction.front' }), value: 'FRONT' },
                        { label: intl.formatMessage({ id: 'ui-plugin-bursar-export.bursarExports.lengthControl.direction.back' }), value: 'BACK' },
                    ] }))); })),
            React.createElement(Col, { xs: 6, md: 3 },
                React.createElement(Field, { name: "".concat(prefix, "truncate"), type: "checkbox", defaultValue: false }, function (fieldProps) { return (React.createElement(Checkbox, __assign({}, fieldProps, { fullWidth: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.lengthControl.truncate" }) }))); })))));
}
